import React, { useState } from 'react';
import { Button, Icon } from '@material-ui/core';
import CreateSiteDialog from '../dialogs/CreateSiteDialog';
import { useSiteContext } from '../SiteContext';
import { useHistory } from 'react-router-dom';
const SiteListControls = () => {
    const history = useHistory();
    const { editorPath } = useSiteContext();
    const [openDialog, setOpenDialog] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'flex' }),
        React.createElement(Button, { variant: 'contained', color: 'secondary', endIcon: React.createElement(Icon, null, "add"), onClick: () => setOpenDialog(true) }, "Add Site"),
        openDialog && (React.createElement(CreateSiteDialog, { open: true, onCancel: () => setOpenDialog(false), onCreated: site => {
                setOpenDialog(false);
                const params = new URLSearchParams({ path: site.path }).toString();
                history.push(`${editorPath}sites/${site.id}?${params}`);
            } }))));
};
export default SiteListControls;
//# sourceMappingURL=SiteListControls.js.map